<template>
  <a-drawer
    :title="(action == 'add' ? '添加' : '修改') + '规则'"
    :width="400"
    :visible="visible"
    @close="
      $emit('update:visible', false);
      form.resetFields();
    "
  >
    <a-form
      :form="form"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
      @submit="handleAlarmOk"
    >
      <a-form-item label="id" v-show="false">
        <a-input v-decorator="['id']"> </a-input>
      </a-form-item>
      <a-form-item label="站点名称">
        <a-select
          placeholder="请选择站点名称"
          v-decorator="[
            'station_name',
            { rules: [{ required: true, message: '请选择站点名称' }] }
          ]"
          option-filter-prop="children"
          showSearch
          filterOption
        >
          <a-select-option
            v-for="(item, index) in stationList"
            :key="index"
            :value="item.station_name"
            >{{ item.station_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="监测类型">
        <a-select
          placeholder="请选择监测类型"
          v-decorator="[
            'param',
            { rules: [{ required: true, message: '请选择监测类型' }] }
          ]"
        >
          <a-select-option
            v-for="(item, index) in sensortypes"
            :key="index"
            :value="item.value"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="最小值">
        <a-input
          v-decorator="[
            'min_threshold',
            {
              rules: [
                {
                  pattern: /^(([1-9]\d*\.?\d*)|(0\.\d*)|0)$/,
                  message: '请输入非负数字'
                }
              ]
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="最大值">
        <a-input
          v-decorator="[
            'max_threshold',
            {
              rules: [
                {
                  pattern: /^(([1-9]\d*\.?\d*)|(0\.\d*)|0)$/,
                  message: '请输入非负数字'
                }
              ]
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="时间间隔">
        <a-input
          v-decorator="[
            'td',
            {
              rules: [
                { required: true, message: '请输入时间间隔' },
                {
                  pattern: /^(([1-9]\d*\.?\d*)|(0\.\d*)|0)$/,
                  message: '请输入非负数字'
                }
              ]
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="启用">
        <a-switch
          v-decorator="[
            'enable',
            { initialValue: false, valuePropName: 'checked' }
          ]"
        />
      </a-form-item>
      <a-form-item label="发送报警">
        <a-switch
          v-decorator="[
            'send_alarm',
            { initialValue: false, valuePropName: 'checked' }
          ]"
        />
      </a-form-item>
    </a-form>

    <div class="drawer-btn">
      <a-button
        :style="{ marginRight: '8px' }"
        @click="
          $emit('update:visible', false);
          form.resetFields();
        "
      >
        取消
      </a-button>
      <a-button type="primary" @click="handleAlarmOk">
        确定
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { addAlarmRule, updateAlarmRule } from "@/api/api";
const editFields = [
  "id",
  "param",
  "max_threshold",
  "station_name",
  "min_threshold",
  "enable",
  "send_alarm"
];

export default {
  data() {
    return {
      form: this.$form.createForm(this)
    };
  },
  props: {
    action: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["authUserInfo", "sensortypes", "groupTree", "stationList"]),
    ...mapGetters(["defaultInfo"])
  },
  mounted() {},
  watch: {
    visible() {
      if (this.action == "edit") {
        this.updateCurAlarmRule();
      }
    }
  },
  methods: {
    handleAlarmOk() {
      this.form.validateFields(async (err, values) => {
        if (err) return;
        let p = "";
        const params = {
          station_id: values.id,
          param: values.param,
          station_name: values.station_name,
          max_threshold: values.max_threshold,
          min_threshold: values.min_threshold,
          td: values.td,
          enable: values.enable ? true : false,
          send_alarm: values.send_alarm ? true : false,
          webhook_id: 69, // 临时设置
          webhook_id_push: 69 // 临时设置
        };
        if (this.action == "add") {
          p = addAlarmRule;
        } else {
          params.id = values.id;
          p = updateAlarmRule;
        }

        try {
          let res = await p(params);
          this.form.resetFields();
          this.$message.success(res.data.msg);
          this.$emit("onOk", false);
        } catch (error) {
          this.$emit("update:visible", false);
          console.log(error);
        }
      });
    },
    updateCurAlarmRule() {
      editFields.forEach(v => this.form.getFieldDecorator(v));
      const form_ = {};
      form_["id"] = this.record["id"];
      form_["param"] = this.record["param"];
      form_["max_threshold"] = this.record["max_threshold"];
      form_["td"] = this.record["td"];
      form_["station_name"] = this.record["station_name"];
      form_["min_threshold"] = this.record["min_threshold"];
      form_["enable"] = this.record["enable"];
      form_["send_alarm"] = this.record["send_alarm"];
      this.$nextTick(() => {
        this.form.setFieldsValue(form_);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.drawer-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
